(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('EmployeeConversionReportInPeriod', EmployeeConversionReportInPeriod);

    EmployeeConversionReportInPeriod.$inject = ['$resource'];

    function EmployeeConversionReportInPeriod ($resource) {
        var resourceUrl =  'api/report/employee-conversion-in-period/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
